module.exports = __webpack_public_path__ + "img/fb.3df01615.svg";